import { useEffect } from 'react';

import { DB_ENVIRONMENT } from '../env.config';
import { debug, getUrlParams } from '../lib/general';
import { useAppStore } from './useAppStore';
import { useInitLanguage } from './useInitLanguage';

export const useAppInit = () => {
    const vm = useAppStore((s) => s.vm);
    const setQrCode = useAppStore((s) => s.setQrCode);
    const setNfc = useAppStore((s) => s.setNfc);

    useInitLanguage(vm?.language_code);

    useEffect(() => {
        const { qr, nfc } = getUrlParams();

        debug(`Using Database in environment: ${DB_ENVIRONMENT || ''}`, 'info')

        if (qr) {
            debug('qr from url: ' + qr, 'data');
            setQrCode(qr);
        }
        if (nfc) {
            setNfc(Boolean(nfc));
        }
    }, []);

};
